export enum EBusinessProviders {
  WIX = 'wix',
  SHOPIFY = 'shopify',
  WOOCOMMERCE = 'woocommerce',
  BIGCOMMERCE = 'bigcommerce',
  FIDEL = 'fidel',
  SQUARE = 'square',
  CLOVER = 'clover',
  TOAST = 'toast'
}
